function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2607 11.6848L51.9661 21.8264C51.3298 22.6044 50.0865 22.3803 49.7618 21.4292L49.3777 20.3039C48.958 19.0742 47.1856 19.1783 46.9126 20.4486L45.3539 27.702C45.0541 29.0969 43.0422 29.0314 42.8338 27.62L39.18 2.8733C38.9723 1.46648 36.9694 1.39482 36.6617 2.78319L31.9017 24.258C31.6119 25.5654 29.7637 25.6079 29.4141 24.3152L25.964 11.5577C25.6163 10.272 23.7811 10.3046 23.4793 11.6019L20.6856 23.611L16.4467 42.3031L14.3822 48.3438C13.9356 49.6505 12.0224 49.4234 11.8942 48.0484L9.24815 19.6704C9.13466 18.4531 7.54327 18.0712 6.88971 19.1044L4.49275 22.8935C3.8991 23.8319 2.47416 23.6224 2.17586 22.5527L0.999872 18.3359",
  stroke: "#15CF74",
  strokeWidth: 2
});

function SvgGraphUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 51,
    viewBox: "0 0 62 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUp);
export default __webpack_public_path__ + "static/media/graphUp.dcee16b057ab2588e047af14a6d8044f.svg";
export { ForwardRef as ReactComponent };